var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form-wrapper",
        { staticClass: "form-wrapper", attrs: { validator: {} } },
        [
          _c(
            "div",
            { staticClass: "information-box" },
            [
              _c("TeamMemberCustomFields", {
                attrs: { value: _vm.member.customFields },
                on: { changed: _vm.handleCustomFieldChanged },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "custom-section-wrapper" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-primary pull-right",
                  attrs: { type: "submit" },
                  on: { click: _vm.update },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }